import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface ConnectionCount extends AttributesMixin<typeof ConnectionCount> { }

@define
export class ConnectionCount extends Model {
  static endpoint = restfulIO('api/v1/ingest/connections/count');

  static attributes = {
    count: Number
  }

  parse(number: Number) {
    return { count: number }
  }
}
